import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"
import config from "@/middlewares/config"
import { useAccountStore } from "@/stores/account"
import { useEstablishmentStore } from "@/stores/establishment"
import { APIDAE_LOCAL_ASSISTANT_ENABLED } from "@/static/LocalAssistantFeatures"
import { canAccessLocalAssistant } from "@/utils/localDiffuser"
import { ensureLocalAssistantRouteContext } from "@/router/waitForEstablishments"

const ensureLocalAssistantAccess = async (fallbackRouteName: string) => {
  await ensureLocalAssistantRouteContext()

  const accountStore = useAccountStore()
  const establishmentStore = useEstablishmentStore()

  if (
    !canAccessLocalAssistant(
      establishmentStore.currentEstablishment,
      accountStore.establishments
    )
  ) {
    return { name: fallbackRouteName }
  }
}

const localAssistantView = () => import("@/views/local-assistant/LocalAssistantView.vue")

const localAssistantRoutes: RouteRecordRaw[] = [
  {
    path: "/local-assistant",
    name: "local-assistant",
    component: localAssistantView,
    beforeEnter: async () => {
      if (!APIDAE_LOCAL_ASSISTANT_ENABLED) {
        return { name: "home" }
      }

      return ensureLocalAssistantAccess("home")
    },
    meta: {
      middleware: [auth, config],
      title: "local_assistant.page_title",
      requiresConfig: true,
    },
  },
  {
    path: "/mes-echanges/assistant-local",
    name: "dialogue-local-assistant",
    component: localAssistantView,
    meta: {
      middleware: [auth],
      title: "local_assistant.page_title",
    },
  },
]

export default localAssistantRoutes
